import {NuxtIcon} from "#components";
import {h} from "vue";
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      stroke: "#262633",
      "stroke-width": "2",
      d: "M12 22c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12c0 1.6.376 3.112 1.043 4.453.178.356.237.763.134 1.148l-.595 2.226a1.3 1.3 0 0 0 1.591 1.591l2.226-.595a1.634 1.634 0 0 1 1.149.133A9.958 9.958 0 0 0 12 22Z"
    }, null, -1),
    _createElementVNode("path", {
      fill: "#262633",
      d: "m10.029 14.942-.648.761.648-.761ZM12 9.5l-.714.7a1 1 0 0 0 1.428 0L12 9.5Zm1.971 5.442-.648-.762.648.762ZM12 15.993v-1 1Zm-1.323-1.813c-.574-.488-1.142-1.047-1.559-1.617-.428-.587-.618-1.08-.618-1.455h-2c0 .993.47 1.903 1.003 2.634.545.746 1.242 1.42 1.878 1.961l1.296-1.523ZM8.5 11.108c0-1.03.453-1.502.84-1.647.4-.149 1.124-.1 1.946.738L12.713 8.8C11.511 7.57 9.985 7.085 8.64 7.588c-1.356.507-2.14 1.874-2.14 3.52h2Zm6.12 4.595c.635-.54 1.332-1.214 1.877-1.961.533-.73 1.003-1.64 1.003-2.634h-2c0 .376-.19.868-.618 1.454-.417.571-.985 1.13-1.559 1.618l1.296 1.523Zm2.88-4.595c0-1.646-.784-3.013-2.14-3.52-1.345-.503-2.87-.017-4.074 1.212l1.428 1.4c.822-.84 1.546-.888 1.945-.739.388.145.841.617.841 1.647h2Zm-8.12 4.595c.765.65 1.456 1.29 2.62 1.29v-2c-.307 0-.44-.062-1.323-.813L9.38 15.703Zm3.943-1.523c-.883.751-1.016.813-1.323.813v2c1.164 0 1.855-.64 2.62-1.29l-1.296-1.523Z"
    }, null, -1)
  ])))
}
export default { render() { return h(NuxtIcon, {icon: {render}, name: "Review"}) } }